// Libs
import classNames from 'classnames/bind';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseMoreAction } from '~/components/common';
// Others
import { IFolder } from '~/utils/interface/folder';
// Styles, images, icons
import styles from './FolderItem.module.scss';
import { icons } from '~/assets';

type Props = {
  folder: IFolder;
  index: number;
  selected?: boolean;
  showAction?: boolean;
  onSelect: (folder: IFolder) => void;
  onEdit: (folder: IFolder) => void;
  onDelete: (folder: IFolder) => void;
};

const cx = classNames.bind(styles);

const FolderItem = (props: Props) => {
  //#region Destructuring Props
  const { folder, selected = false, showAction, onSelect, onEdit, onDelete } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <ListItemButton
      divider
      key={folder.id}
      selected={selected}
      classes={{ selected: cx('itemSelected'), root: cx('itemRoot') }}
      onClick={() => onSelect(folder)}
    >
      <ListItemIcon classes={{ root: cx('iconFolder') }}>
        <img
          src={selected ? icons.documentIconFolderActive : icons.documentIconFolderInactive}
          alt={t('common_alt_img')}
        />
      </ListItemIcon>

      <ListItemText classes={{ primary: cx('folderName', { selected }) }} primary={folder.name} />

      {showAction && (
        <BaseMoreAction
          icon={selected ? icons.commonIconMoreActive : icons.commonIconMoreInactive}
          actions={[
            {
              label: t('table_action_edit'),
              icon: <img src={icons.tableIconActionEdit} alt={t('common_alt_img')} width={16} height={16} />,
              onClick: () => onEdit(folder),
            },
            {
              hasOtherColor: true,
              label: t('table_action_delete'),
              icon: (
                <img src={icons.tableIconActionDelete} alt={t('common_alt_img')} width={16} height={16} />
              ),
              onClick: () => onDelete(folder),
            },
          ]}
        />
      )}
    </ListItemButton>
  );
};

export default FolderItem;
